module.exports = __webpack_public_path__ + "assets/37.jpg?182ac2d837a585ade84e5f2ac3dff416";